import { render, staticRenderFns } from "./publish-overview-table.vue?vue&type=template&id=67cc19ab"
import script from "./publish-overview-table.vue?vue&type=script&lang=js"
export * from "./publish-overview-table.vue?vue&type=script&lang=js"
import style0 from "./publish-overview-table.vue?vue&type=style&index=0&id=67cc19ab&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports